import { computed } from "vue";
import { useInspectionStore } from "@/stores/inspection";
import { SAFETY_FEATURE_TYPES } from "@/constants/InspectionConstants";

export default function useApproachData() {
  const inspectionStore = useInspectionStore();

  let structure = computed(() => inspectionStore.selectedInspection);
  let safetyFeatureObj = computed({
    get() {
      return structure.value?.safetyFeatures;
    },
    set(value) {
      structure.value.safetyFeatures = value;
    },
  });

  const getDefaultDescriptionFromSafetyFeature = (sfArray, sfType) => {
    return sfArray?.length > 0 ? sfArray.find((featureType) => featureType.safetyFeatureType == sfType)?.sfDesc : null;
  }

  function getSafetyFeature(safetyFeatureType, safetyFeatureDescription) {
    return {
      brkey: structure.value.structureBridge.brkey,
      controlFeature: null,
      inspectionId: structure.value.inspection.inspectionId,
      location: null,
      updateDateTime: null,
      safetyFeatureType: safetyFeatureType,
      sfDesc: safetyFeatureDescription,
      updateUserId: structure.value.userInspection.updateUserId,
    };
  }

  function setSafetyFeature(safetyFeatureType, safetyFeatureDescription) {
    const safetyObj = safetyFeatureObj.value?.find((sf) => sf.safetyFeatureType == safetyFeatureType);
    return safetyObj || getSafetyFeature(safetyFeatureType, safetyFeatureDescription);
  }

  const bridgeRailingDesc = computed({
    get() {
      return getDefaultDescriptionFromSafetyFeature(
        structure.value?.safetyFeatures,
        SAFETY_FEATURE_TYPES.BRIDGE_RAILING
      );
    },
    set(param) {
      let bridgeFeatureType = safetyFeatureObj.value?.find(
        (sf) => sf.safetyFeatureType == SAFETY_FEATURE_TYPES.BRIDGE_RAILING,
      );
      if (bridgeFeatureType) {
        bridgeFeatureType.sfDesc = param;
      } else {
        safetyFeatureObj.value = [
          getSafetyFeature(SAFETY_FEATURE_TYPES.BRIDGE_RAILING, param),
          setSafetyFeature(SAFETY_FEATURE_TYPES.TRANSITION, null),
        ];
      }
    },
  });

  const transitionDesc = computed({
    get() {
      return getDefaultDescriptionFromSafetyFeature(structure.value?.safetyFeatures, SAFETY_FEATURE_TYPES.TRANSITION);
    },
    set(param) {
      let transitionFeatureType = safetyFeatureObj.value?.find(
        (sf) => sf.safetyFeatureType == SAFETY_FEATURE_TYPES.TRANSITION,
      );
      if (transitionFeatureType) {
        transitionFeatureType.sfDesc = param;
      } else {
        safetyFeatureObj.value = [
          setSafetyFeature(SAFETY_FEATURE_TYPES.BRIDGE_RAILING, null),
          getSafetyFeature(SAFETY_FEATURE_TYPES.TRANSITION, param),
        ];
      }
    },
  });

  return {
    bridgeRailingDesc,
    transitionDesc,
  };
};
